/**
 * TrueSkill rating utilities to eliminate code duplication
 */

import { SIGMA_FLOOR } from '../constants/gameConstants.js';

/**
 * Calculate conservative rating estimate (mu - 3 * effectiveSigma)
 * Uses sigma floor to cap advantage from playing many games
 * @param {number} mu - Mean skill level
 * @param {number} sigma - Skill uncertainty
 * @returns {number} Conservative rating
 */
export const calculateConservativeRating = (mu, sigma) => {
  const effectiveSigma = Math.max(sigma, SIGMA_FLOOR);
  return mu - 3 * effectiveSigma;
};

/**
 * Calculate effective skill level for display
 * @param {Object} player - Player object with mu and sigma
 * @returns {number} Effective skill level
 */
export const calculateEffectiveSkill = player => {
  if (
    !player ||
    typeof player.mu !== 'number' ||
    typeof player.sigma !== 'number'
  ) {
    return 0;
  }
  return calculateConservativeRating(player.mu, player.sigma);
};
